// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1li03","left":"styles_left__1Qigy","right":"styles_right__3DsEg","alert":"styles_alert__1FhAV"};